import { createSignal } from "solid-js";
export const [selectionMode, setSelectionMode] = createSignal(false);
